import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 1.84497C8.04837 1.84497 4.84497 5.04837 4.84497 8.99997C4.84497 11.3172 5.94649 13.3771 7.65447 14.6847C7.14537 14.8891 6.64964 15.1299 6.17125 15.406C4.39926 16.4287 2.9276 17.8998 1.90413 19.6713C1.58502 20.2236 1.77409 20.9301 2.32642 21.2492C2.87875 21.5683 3.5852 21.3792 3.9043 20.8269C4.72499 19.4064 5.90507 18.2268 7.32596 17.4067C8.74683 16.5866 10.3585 16.155 11.9991 16.155C13.6396 16.155 15.2513 16.5867 16.6722 17.4068C18.0931 18.2269 19.2731 19.4065 20.0938 20.8271C20.4129 21.3794 21.1194 21.5685 21.6717 21.2494C22.2241 20.9302 22.4131 20.2238 22.094 19.6715C21.0705 17.9 19.599 16.4289 17.827 15.4061L17.827 15.4061C17.3489 15.1302 16.8535 14.8896 16.3448 14.6852C18.0532 13.3776 19.155 11.3175 19.155 8.99997C19.155 5.04837 15.9516 1.84497 12 1.84497ZM7.15497 8.99997C7.15497 6.32415 9.32415 4.15497 12 4.15497C14.6758 4.15497 16.845 6.32415 16.845 8.99997C16.845 11.6758 14.6758 13.845 12 13.845C9.32415 13.845 7.15497 11.6758 7.15497 8.99997Z",
      fill: "#101B31"
    }, null, -1)
  ]))]))
}
export default { render: render }